<template>
    <validation-provider
        :rules="rules"
        :name="name"
        v-bind="$attrs"
        v-slot="{errors, valid, invalid, validated}"
    >
        <b-form-group>
            <slot name="label">
                <label v-if="label" :class="labelClasses">
                    {{ label }}
                </label>
            </slot>
            <div
                :class="[
                   {'input-group': hasIcon},
                   {'focused': focused},
                   {'input-group-alternative': alternative},
                   {'has-label': label || $slots.label},
                   inputGroupClasses
                ]">

                <div v-if="prependIcon || $slots.prepend" class="input-group-prepend">
                    <slot name="prepend">
                        <span class="input-group-text">
                            <i :class="prependIcon"></i>
                        </span>
                    </slot>
                </div>

                <slot v-bind="slotData">
                    <flat-picker
                        :valid="valid"
                        v-model="actualValue"
                        v-on="listeners"
                        :required="required"
                        class="form-control datepicker"
                        :class="[
                            {'is-valid': valid && validated && successMessage},
                            {'is-invalid': invalid && validated}, inputClasses
                        ]"
                    />
                </slot>
                <div v-if="appendIcon || $slots.append" class="input-group-append">
                    <slot name="append">
                        <span class="input-group-text">
                            <i :class="appendIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot name="infoBlock"></slot>
            </div>
            <transition :name="animation" appear>
                <slot name="success">
                    <div
                        class="valid-feedback"
                        v-if="valid && validated && successMessage">
                        {{ successMessage }}
                    </div>
                </slot>
                <slot name="error" :errors="errors">
                    <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
                        {{ errors[0] }}
                    </div>
                </slot>
            </transition>
        </b-form-group>
    </validation-provider>
</template>
<script>

import flatPicker from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import ValidatedFieldMixin from './ValidatedFieldMixin';

export default {
    inheritAttrs: false,
    name: 'validated-date-picker',
    mixins: [ValidatedFieldMixin],
    components: {
        flatPicker
    },

    mounted () {
        this.actualValue = this.value;
    },

    data () {
        return {
            actualValue: ''
        };
    },

    computed: {
        listeners () {
            return {
                ...this.$listeners,
                input: this.updateValue,
                'on-open': this.onFocus,
                'on-close': this.onBlur
            };
        }
    },

    methods: {
        updateValue (value) {
            this.$emit('input', value);
        }
    }
};
</script>
<style></style>
